import React from 'react';

const Dashboard = React.lazy(() => import('./views/dashboard/Dashboard'));
const Onboarding = React.lazy(() => import('./views/onboarding/Onboarding'));

const Users = React.lazy(() => import('./views/users/Users'));
const CreateUser = React.lazy(() => import('./views/users/CreateUser'));
const UpdateUser = React.lazy(() => import('./views/users/UpdateUser'));
const LoginHistoryPage = React.lazy(() => import('./views/users/LoginHistoryPage'));

//Roles
const RoleList = React.lazy(() => import('./views/role/RoleList'));
const CreateRole = React.lazy(() => import('./views/role/CreateRole'));
const UpdateRole = React.lazy(() => import('./views/role/UpdateRole'));
const ApiAccessList = React.lazy(() => import('./views/api-access/AccessList'));

//Settings
const FormSettings = React.lazy(() => import('./views/site/settings/FormSettings'));
const ConfirmDelete = React.lazy(() => import('./views/site/settings/ConfirmDelete'));
const FormProfile = React.lazy(() => import('./views/site/profile/FormProfile'));
const FormChangePassword = React.lazy(() => import('./views/site/profile/FormChangePassword'));

//Item
const ItemList = React.lazy(() => import('./views/item/ItemList'));
const CreateItem = React.lazy(() => import('./views/item/CreateItem'));
const UpdateItem = React.lazy(() => import('./views/item/UpdateItem'));
const ItemForm = React.lazy(() => import('./views/item/ItemForm'));
const ItemNumbering = React.lazy(() => import('./views/item/ItemNumbering'));
const ImportItem = React.lazy(() => import('./views/item/ImportItem'));
const ImportMinimumStock = React.lazy(() => import('./views/item/ImportMinimumStock'));

//BOM
const BomList = React.lazy(() => import('./views/bom/BomList'));
const CreateBom = React.lazy(() => import('./views/bom/CreateBom'));
const UpdateBom = React.lazy(() => import('./views/bom/UpdateBom'));

//Business Partner
const BusinessPartnerList = React.lazy(() => import('./views/business-partner/BusinessPartnerList'));
const CreateBusinessPartner = React.lazy(() => import('./views/business-partner/CreateBusinessPartner'));
const UpdateBusinessPartner = React.lazy(() => import('./views/business-partner/UpdateBusinessPartner'));

//Inventory Order
const InventoryOrderList = React.lazy(() => import('./views/inventory-order/InventoryOrderList'));
const CreateInventoryOrder = React.lazy(() => import('./views/inventory-order/CreateInventoryOrder'));
const UpdateInventoryOrder = React.lazy(() => import('./views/inventory-order/UpdateInventoryOrder'));
const PrintInventoryOrder = React.lazy(() => import('./views/inventory-order/PrintInventoryOrder'));
const InventoryOrderFulfillmentReport = React.lazy(() => import('./views/inventory-order/InventoryOrderFulfillmentReport'));

//Item Category
const ItemCategoryList = React.lazy(() => import('./views/item/category/ItemCategoryList'));
const CreateItemCategory = React.lazy(() => import('./views/item/category/CreateItemCategory'));
const UpdateItemCategory = React.lazy(() => import('./views/item/category/UpdateItemCategory'));
const ImportItemCategory = React.lazy(() => import('./views/item/category/ImportItemCategory'));

//Locator
const LocatorList = React.lazy(() => import('./views/locator/LocatorList'));
const CreateLocator = React.lazy(() => import('./views/locator/CreateLocator'));
const UpdateLocator = React.lazy(() => import('./views/locator/UpdateLocator'));
const ImportLocator = React.lazy(() => import('./views/locator/ImportLocator'));

//Warehouse
const WarehouseList = React.lazy(() => import('./views/warehouse/WarehouseList'));
const CreateWarehouse = React.lazy(() => import('./views/warehouse/CreateWarehouse'));
const UpdateWarehouse = React.lazy(() => import('./views/warehouse/UpdateWarehouse'));

//Unit of Measure
const UomList = React.lazy(() => import('./views/uom/UomList'));
const CreateUom = React.lazy(() => import('./views/uom/CreateUom'));
const UpdateUom = React.lazy(() => import('./views/uom/UpdateUom'));
const ImportUom = React.lazy(() => import('./views/uom/ImportUom'));

//Email Template
const TemplateList = React.lazy(() => import('./views/email/TemplateList'));
const UpdateTemplate = React.lazy(() => import('./views/email/UpdateTemplate'));

//Print Template
const PrintTemplateList = React.lazy(() => import('./views/print-template/TemplateList'));
const PrintTemplateEditor = React.lazy(() => import('./views/print-template/TemplateEditor'));

//Custom Field
const CustomFieldList = React.lazy(() => import('./views/field/CustomFieldList'));
const CreateCustomField = React.lazy(() => import('./views/field/CreateCustomField'));
const UpdateCustomField = React.lazy(() => import('./views/field/UpdateCustomField'));

//Transaction Category
const TransactionCategoryList = React.lazy(() => import('./views/transaction/category/TransactionCategoryList'));
const CreateTransactionCategory = React.lazy(() => import('./views/transaction/category/CreateTransactionCategory'));
const UpdateTransactionCategory = React.lazy(() => import('./views/transaction/category/UpdateTransactionCategory'));

//Calendar Period
const PeriodList = React.lazy(() => import('./views/calendar/PeriodList'));

//Transaction
const ReceiptList = React.lazy(() => import('./views/transaction/type/receipt/ReceiptList'));
const CreateTransactionReceipt = React.lazy(() => import('./views/transaction/type/receipt/CreateTransactionReceipt'));
const UpdateTransactionReceipt = React.lazy(() => import('./views/transaction/type/receipt/UpdateTransactionReceipt'));
const TransactionReceiptForm = React.lazy(() => import('./views/transaction/form/receipt/TransactionReceiptForm'));

const IssueList = React.lazy(() => import('./views/transaction/type/issue/IssueList'));
const CreateTransactionIssue = React.lazy(() => import('./views/transaction/type/issue/CreateTransactionIssue'));
const UpdateTransactionIssue = React.lazy(() => import('./views/transaction/type/issue/UpdateTransactionIssue'));
const TransactionIssueForm = React.lazy(() => import('./views/transaction/form/issue/TransactionIssueForm'));

const MoveList = React.lazy(() => import('./views/transaction/type/move/MoveList'));
const CreateTransactionMove = React.lazy(() => import('./views/transaction/type/move/CreateTransactionMove'));
const UpdateTransactionMove = React.lazy(() => import('./views/transaction/type/move/UpdateTransactionMove'));
const TransactionMoveForm = React.lazy(() => import('./views/transaction/form/move/TransactionMoveForm'));

const AdjustmentList = React.lazy(() => import('./views/transaction/type/adjustment/AdjustList'));
const CreateTransactionAdjustment = React.lazy(() => import('./views/transaction/type/adjustment/CreateTransactionAdjustment'));
const UpdateTransactionAdjustment = React.lazy(() => import('./views/transaction/type/adjustment/UpdateTransactionAdjustment'));
const TransactionAdjustmentForm = React.lazy(() => import('./views/transaction/form/adjustment/TransactionAdjustmentForm'));

const AssemblyList = React.lazy(() => import('./views/transaction/type/assembly/AssemblyList'));
const CreateTransactionAssembly = React.lazy(() => import('./views/transaction/type/assembly/CreateTransactionAssembly'));
const UpdateTransactionAssembly = React.lazy(() => import('./views/transaction/type/assembly/UpdateTransactionAssembly'));

const DisassemblyList = React.lazy(() => import('./views/transaction/type/disassembly/DisassemblyList'));
const CreateTransactionDisassembly = React.lazy(() => import('./views/transaction/type/disassembly/CreateTransactionDisassembly'));
const UpdateTransactionDisassembly = React.lazy(() => import('./views/transaction/type/disassembly/UpdateTransactionDisassembly'));
const StockTransformationList = React.lazy(() => import('./views/transaction/type/transformation/StockTransformationList'));

//Report
const ReportDetailStockList = React.lazy(() => import('./views/report/detail/ReportDetailStockList'));
const ReportDailyStockPivotList = React.lazy(() => import('./views/report/pivot/ReportDailyStockPivotList'));
const ReportSummaryStockList = React.lazy(() => import('./views/report/summary/ReportSummaryStockList'));
const ReportLocatorMinimumStockList = React.lazy(() => import('./views/report/minimum/ReportLocatorMinimumStockList'));
const ReportMinimumStockList = React.lazy(() => import('./views/report/minimum/ReportMinimumStockList'));

const routes = [
  { path: '/', exact: true, name: 'Home' },
  { path: '/onboarding', name: 'Onboarding', component: Onboarding },
  { path: '/dashboard/fallback', name: 'Operational Overview', component: Dashboard },
  { path: '/dashboard', name: 'Dashboard', component: Dashboard },

  { path: '/item/category/:id/update', name: 'Update Item Category', component: UpdateItemCategory },
  { path: '/item/category/create', name: 'Create Item Category', component: CreateItemCategory },
  { path: '/item/category/import', name: 'Import Item Categories', component: ImportItemCategory },
  { path: '/item/category', exact: true, name: 'Item Category List', component: ItemCategoryList },
  { path: '/item/numbering', exact: true, name: 'Item Numbering', component: ItemNumbering },

  { path: '/item/:id/update', name: 'Update Item', component: UpdateItem },
  { path: '/item/create', name: 'Create Item', component: CreateItem },
  { path: '/item/stock/minimum/import', name: 'Import Minimum Stock', component: ImportMinimumStock },
  { path: '/item/import', name: 'Import Items', component: ImportItem },
  { path: '/item/form', name: 'Item Form', component: ItemForm },
  { path: '/item', exact: true, name: 'Item List', component: ItemList },

  { path: '/bom/:id/update', name: 'Update BOM', component: UpdateBom },
  { path: '/bom/create', name: 'Create BOM', component: CreateBom },
  { path: '/bom', exact: true, name: 'BOM List', component: BomList },

  { path: '/business-partner/:id/update', name: 'Update Business Partner', component: UpdateBusinessPartner },
  { path: '/business-partner/create', name: 'Create Business Partner', component: CreateBusinessPartner },
  { path: '/business-partner', exact: true, name: 'Business Partner List', component: BusinessPartnerList },

  { path: '/inventory-order/internal-request/create', name: 'Create Internal Request', component: CreateInventoryOrder },
  { path: '/inventory-order/supplier-request/create', name: 'Create Supplier Request', component: CreateInventoryOrder },
  { path: '/inventory-order/customer-request/create', name: 'Create Customer Request', component: CreateInventoryOrder },
  { path: '/inventory-order/internal-request', exact: true, name: 'Internal Request List', component: InventoryOrderList },
  { path: '/inventory-order/supplier-request', exact: true, name: 'Supplier Request List', component: InventoryOrderList },
  { path: '/inventory-order/customer-request', exact: true, name: 'Customer Request List', component: InventoryOrderList },
  { path: '/inventory-order/:id/print', name: 'Print Inventory Order', component: PrintInventoryOrder },
  { path: '/inventory-order/:id/update', name: 'Update Inventory Order', component: UpdateInventoryOrder },
  { path: '/inventory-order/create', name: 'Create Inventory Order', component: CreateInventoryOrder },
  { path: '/inventory-order', exact: true, name: 'Inventory Order List', component: InventoryOrderList },

  { path: '/locator/:id/update', name: 'Update Warehouse', component: UpdateLocator },
  { path: '/locator/create', name: 'Create Warehouse', component: CreateLocator },
  { path: '/locator/import', name: 'Import Warehouses', component: ImportLocator },
  { path: '/locator', exact: true, name: 'Warehouse List', component: LocatorList },

  { path: '/warehouse/:id/update', name: 'Update Warehouse', component: UpdateWarehouse },
  { path: '/warehouse/create', name: 'Create Warehouse', component: CreateWarehouse },
  { path: '/warehouse', exact: true, name: 'Warehouse List', component: WarehouseList },

  { path: '/uom/:id/update', name: 'Update Unit of Measure', component: UpdateUom },
  { path: '/uom/import', name: 'Import Unit of Measures', component: ImportUom },
  { path: '/uom/create', name: 'Create Unit of Measure', component: CreateUom },
  { path: '/uom', exact: true, name: 'Unit of Measure List', component: UomList },

  { path: '/email/template', exact: true, name: 'Email Template List', component: TemplateList },
  { path: '/email/template/:id/update', name: 'Update Email Template', component: UpdateTemplate },
  { path: '/print/template', exact: true, name: 'Print Template List', component: PrintTemplateList },
  { path: '/print/template/create', name: 'Create Print Template', component: PrintTemplateEditor },
  { path: '/print/template/:id/update', name: 'Update Print Template', component: PrintTemplateEditor },

  { path: '/field/:id/update', name: 'Update Custom Field', component: UpdateCustomField },
  { path: '/field/create', name: 'Create Custom Field', component: CreateCustomField },
  { path: '/field', name: 'Custom Field List', component: CustomFieldList },

  { path: '/transaction/category/:id/update', name: 'Update Transaction Category', component: UpdateTransactionCategory },
  { path: '/transaction/category/create', name: 'Create Transaction Category', component: CreateTransactionCategory },
  { path: '/transaction/category', name: 'Transaction Category List', component: TransactionCategoryList },

  { path: '/calendar/period', name: 'Calendar Period', component: PeriodList },

  { path: '/transaction/receipt/:id/update', name: 'Update Receipt', component: UpdateTransactionReceipt },
  { path: '/transaction/receipt/form', name: 'Transaction Receipt Form', component: TransactionReceiptForm },
  { path: '/transaction/receipt/create', name: 'Create Receipt', component: CreateTransactionReceipt },
  { path: '/transaction/receipt', name: 'Receipt List', component: ReceiptList },

  { path: '/transaction/issue/:id/update', name: 'Update Issue', component: UpdateTransactionIssue },
  { path: '/transaction/issue/form', name: 'Transaction Issue Form', component: TransactionIssueForm },
  { path: '/transaction/issue/create', name: 'Create Issue', component: CreateTransactionIssue },
  { path: '/transaction/issue', name: 'Issue List', component: IssueList },

  { path: '/transaction/move/:id/update', name: 'Update Movement', component: UpdateTransactionMove },
  { path: '/transaction/move/form', name: 'Transaction Movement Form', component: TransactionMoveForm },
  { path: '/transaction/move/create', name: 'Create Movement', component: CreateTransactionMove },
  { path: '/transaction/move', name: 'Movement List', component: MoveList },

  { path: '/transaction/adjustment/:id/update', name: 'Update Adjustment', component: UpdateTransactionAdjustment },
  { path: '/transaction/adjustment/form', name: 'Transaction Adjustment Form', component: TransactionAdjustmentForm },
  { path: '/transaction/adjustment/create', name: 'Create Adjustment', component: CreateTransactionAdjustment },
  { path: '/transaction/adjustment', name: 'Adjustment List', component: AdjustmentList },

  { path: '/transaction/transformation', name: 'Stock Transformation', component: StockTransformationList },

  { path: '/transaction/assembly/:id/update', name: 'Update Assembly', component: UpdateTransactionAssembly },
  { path: '/transaction/assembly/create', name: 'Create Assembly', component: CreateTransactionAssembly },
  { path: '/transaction/assembly', name: 'Assembly List', component: AssemblyList },

  { path: '/transaction/disassembly/:id/update', name: 'Update Disassembly', component: UpdateTransactionDisassembly },
  { path: '/transaction/disassembly/create', name: 'Create Disassembly', component: CreateTransactionDisassembly },
  { path: '/transaction/disassembly', name: 'Disassembly List', component: DisassemblyList },

  { path: '/report/stock/detail', name: 'Detail Stock', component: ReportDetailStockList },
  { path: '/report/stock/daily-pivot', name: 'Daily Stock Pivot', component: ReportDailyStockPivotList },
  { path: '/report/stock/summary', name: 'Summary Stock', component: ReportSummaryStockList },
  { path: '/report/stock/minimum', exact: true, name: 'Minimum Stock', component: ReportMinimumStockList },
  { path: '/report/stock/minimum/locator', exact: true, name: 'Warehouse Minimum Stock', component: ReportLocatorMinimumStockList },
  { path: '/report/inventory-order/fulfillment', exact: true, name: 'Order Fulfillment', component: InventoryOrderFulfillmentReport },

  { path: '/user/:id/update', name: 'Update User', component: UpdateUser },
  { path: '/user/login-history', exact: true, name: 'Login History', component: LoginHistoryPage },
  { path: '/user/create', name: 'Create User', component: CreateUser },
  { path: '/user', name: 'Users', component: Users },

  { path: '/role/:id/update', name: 'Update Role', component: UpdateRole },
  { path: '/role/create', name: 'Create Role', component: CreateRole },
  { path: '/role', name: 'Roles & Permissions', component: RoleList },
  { path: '/api-access', exact: true, name: 'API Access', component: ApiAccessList },

  { path: '/site/settings', name: 'Settings', component: FormSettings },
  { path: '/site/delete/:id', name: 'Confirm Delete', component: ConfirmDelete },
  { path: '/site/profile', name: 'Settings', component: FormProfile },
  { path: '/site/login-history', exact: true, name: 'Login History', component: LoginHistoryPage },
  { path: '/password/change', exact: true, name: 'Change Password', component: FormChangePassword }
];

export default routes;
